import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_55daa337-b083-4bba-81d0-04d8a52c32f6/artifacts/6cgwa6q5_DODIPA_logo_380x380.jpg";

const navLinks = [
  { href: '#servizi', label: 'Servizi' },
  { href: '#perche-noi', label: 'Perché Noi' },
  { href: '#chi-siamo', label: 'Chi Siamo' },
  { href: '#contatti', label: 'Contatti' },
];

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav 
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-[#0B1121]/95 backdrop-blur-xl border-b border-white/5 py-3' 
          : 'bg-transparent py-5'
      }`}
    >
      <div className="container-custom flex items-center justify-between">
        {/* Logo */}
        <a 
          href="#" 
          onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
          className="logo-hover flex items-center gap-3"
          data-testid="navbar-logo"
        >
          <img 
            src={LOGO_URL} 
            alt="DODIPA Logo" 
            className="h-10 w-10 md:h-12 md:w-12 rounded-lg object-contain bg-white"
          />
          <span className="font-heading font-bold text-xl md:text-2xl text-white">
            DODIPA
          </span>
        </a>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => scrollToSection(e, link.href)}
              className="nav-link text-white/80 hover:text-white font-medium text-sm tracking-wide"
              data-testid={`nav-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contatti"
            onClick={(e) => scrollToSection(e, '#contatti')}
            className="btn-primary bg-[#F5A547] text-black font-bold px-6 py-2.5 rounded-full text-sm neon-orange"
            data-testid="nav-cta-button"
          >
            Richiedi Consulenza
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden p-2 text-white"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          data-testid="mobile-menu-button"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div 
          className="mobile-menu md:hidden absolute top-full left-0 right-0 border-t border-white/5"
          data-testid="mobile-menu"
        >
          <div className="container-custom py-6 flex flex-col gap-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => scrollToSection(e, link.href)}
                className="text-white/80 hover:text-white font-medium py-2 text-lg"
                data-testid={`mobile-nav-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contatti"
              onClick={(e) => scrollToSection(e, '#contatti')}
              className="btn-primary bg-[#F5A547] text-black font-bold px-6 py-3 rounded-full text-center mt-2 neon-orange"
              data-testid="mobile-nav-cta-button"
            >
              Richiedi Consulenza
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
